export interface DefaultRemoteConfigFlags {
  jukeRadioWebFeatureFlagBoolean?: string | number | boolean;
  jukeRadioWebFeatureFlagString?: string | number | boolean;
  showWebsiteOfTheYearLogo?: boolean;
}

// Default values for feature flags, swap this with real feature flags when we create it
const defaultRemoteConfigFlags = {
  jukeRadioWebFeatureFlagBoolean: true,
  jukeRadioWebFeatureFlagString: 'temporary feature flag',
  showWebsiteOfTheYearLogo: false,
};

export default defaultRemoteConfigFlags;
